var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSituation1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3002.05 3002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-11{fill:none;}.cls-2{fill:url(#D\xE9grad\xE9_sans_nom_22);}.cls-3{fill:#a0a0a0;}.cls-4{fill:#c4c4c4;}.cls-5{fill:url(#D\xE9grad\xE9_sans_nom_22-2);}.cls-6{clip-path:url(#clip-path);}.cls-7{fill:#d57f44;}.cls-10,.cls-11,.cls-12,.cls-15,.cls-16,.cls-19,.cls-7{stroke:#000;stroke-miterlimit:10;}.cls-8{fill:url(#D\xE9grad\xE9_sans_nom_34);}.cls-9{fill:url(#D\xE9grad\xE9_sans_nom_34-2);}.cls-10{stroke-width:0.5px;}.cls-12{fill:#333;}.cls-13{fill:#0e0d0b;}.cls-14{fill:#b75036;}.cls-15{fill:#1a1a19;}.cls-16{fill:#0d0d0b;}.cls-17{fill:#474747;}.cls-18{clip-path:url(#clip-path-2);}.cls-19{fill:#e5e5e3;}.cls-20{fill:#181715;}.cls-21{fill:#edf1f2;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22",
    x1: 1502.02,
    y1: 3002,
    x2: 1502.02,
    y2: 1547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a8adad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#b8bcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#cfd3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e0e4e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#eaeeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edf1f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_22-2",
    x1: 1500,
    y1: 1538,
    x2: 1500,
    y2: 0,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_22"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1030.5,2060.5s-22,10-28-91-8-409-8-409-1-76,36-115c-11,0-17,1-20-2s-4-37,0-39,54-2,54-2v-27h-42v-95h9v-57l33-59h11v-198s5-16,14-16,12,15,12,15v199h14l25,61v55h11v95h-44v27h40v4h95v-66s10,2,10,8-2,23,3,27,12,17,27,17h83s119-5,147,23c14,12,6,42-13,48s-50.36,7.86-99,6c-50.13-1.92-103.22-8.54-122-6-16,3-23,11-23,19s2,28-2,31-12,2-12,2v-70h-93v10l81,112s9,3,11,35,4,116,4,116l-8,8v157s41,27,43,36,0,36,0,36,88,9,88,42c0,29,71,32,71,32s39,2,47-22c10-7,50,1,45,18s-23,85-31,89-20,0-20,0-3,9-17,11-123,4-217-28-127-50-148-54-22-10-39,3S1030.5,2060.5,1030.5,2060.5Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_34",
    x1: 1146.5,
    y1: 1428,
    x2: 1263.5,
    y2: 1428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a8adad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#aaafaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#b1b6b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#bec2c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#cfd4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#e6eaeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#edf1f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#dce0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#c1c4c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#acaeaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9d9fa0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#949697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_34-2",
    x1: 950,
    y1: 1244,
    x2: 1260,
    y2: 1244,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_34"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1200,683s25-38,3-82V560s33.5-63.5,297.5-60.5,301,62.5,301,62.5v40.5s-35.5,57,2.5,79V712s-4,78-306,78c-227.79,0-287.18-46.65-298.32-80.31C1199.68,699,1200,692,1200,683Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Situation 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2 3002 2 1547 653 1624 3002.05 1620.43 3002 3002 2 3002"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "2 1583 694 1656 3002 1669 3002 1569 375 1425 2 1431 2 1583"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "2 1502 694 1601 3002 1581 3002 1514 375 1370 2 1376 2 1502"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "0 1424 717 1538 3000 1512 3000 0 0 0 0 1424"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_3",
    "data-name": "Calque 3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1031,2060s-22,10-28-91-8-409-8-409-1-76,36-115c-11,0-17,1-20-2s-4-37,0-39,54-2,54-2v-27h-42v-95h9v-57l33-59h11V966s5-16,14-16,12,15,12,15v199h14l25,61v55h11v95h-44v27h40v4h95v-66s10,2,10,8-2,23,3,27,12,17,27,17h83s119-5,147,23c14,12,6,42-13,48s-50.36,7.86-99,6c-50.13-1.92-103.22-8.54-122-6-16,3-23,11-23,19s2,28-2,31-12,2-12,2v-70h-93v10l81,112s9,3,11,35,4,116,4,116l-8,8v157s41,27,43,36,0,36,0,36,88,9,88,42c0,29,71,32,71,32s39,2,47-22c10-7,50,1,45,18s-23,85-31,89-20,0-20,0-3,9-17,11-123,4-217-28-127-50-148-54-22-10-39,3S1031,2060,1031,2060Z",
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1146.5,
    y: 1334.5,
    width: 117,
    height: 187
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "984.81 1623 1260 1623 1223 1508 1151 1447 1151 1392 1187 1359 1165 902 1049 865 950 1017 984.81 1623"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1033,
    y1: 1447.5,
    x2: 1151,
    y2: 1447.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1149.5,
    y1: 1407.5,
    x2: 1150.5,
    y2: 1448
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1070.29,1621s-8.73-45.93,17.21-53.5c24-7,161-12,161-12",
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 1136,
    cy: 1541,
    r: 42.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1032.5,2067.5s9-255,32-313c24-52,97-42,97-42",
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1049,2059v-62s65.85,52.2,102,56c19,2,30-2,40-19,20,0,62,9,62,9s1,30,26,39,48-14,48-14,89,40,102,56-8,32-8,32Z",
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 1296,
    cy: 2051,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1237,1878s-2,26-2,30c12,6,22,9,23,13s-3,49,1,52,92.63,29.37,109.81,29.18.19-64.18.19-64.18Z",
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1248.5,1693.5s-23,3-29,25-12,163-11,224,57,70,57,70,115,38,190,50,45-103,45-103l-129.08,46s.08,15-7.92,14-93-21-100-25-27.27-10.41-30-35c-3-27,14-218,22-223S1248.5,1693.5,1248.5,1693.5Z",
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1182,1947c7,10,11,51-9,67s-62,22-95-34c-10.5-31-3.5-48.5,1.5-50.5,9.19-2.81,24.75,8.25,27.5,10.5C1112.5,1944.5,1175,1937,1182,1947Z",
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 1002.17,
    y1: 1900.34,
    x2: 1237.56,
    y2: 1900.34
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "1533.5 1516.5 1273.5 1507.5 1257.5 1480.3 1257.5 1366.5 1533.5 1366.5 1533.5 1516.5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 1294.5,
    cy: 2050.5,
    r: 19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 993.5,
    y: 1623.5,
    width: 264,
    height: 55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1077,
    y1: 1166.5,
    x2: 1103,
    y2: 1166.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1064.5,
    y: 1377.5,
    width: 47,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1028,
    y: 1226,
    width: 135,
    height: 56.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1069,1083s18-7,36,35c7.23,16.87,1-20,1-20s-8-35-37-31S1069,1083,1069,1083Z",
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1069,1037s18-7,36,35c7.23,16.87,1-20,1-20s-8-35-37-31S1069,1037,1069,1037Z",
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1069,988s18-7,36,35c7.23,16.87,1-20,1-20s-8-35-37-31S1069,988,1069,988Z",
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1030.5,2060.5s-22,10-28-91-8-409-8-409-1-76,36-115c-11,0-17,1-20-2s-4-37,0-39,54-2,54-2v-27h-42v-95h9v-57l33-59h11v-198s5-16,14-16,12,15,12,15v199h14l25,61v55h11v95h-44v27h40v4h95v-66s10,2,10,8-2,23,3,27,12,17,27,17h83s119-5,147,23c14,12,6,42-13,48s-50.36,7.86-99,6c-50.13-1.92-103.22-8.54-122-6-16,3-23,11-23,19s2,28-2,31-12,2-12,2v-70h-93v10l81,112s9,3,11,35,4,116,4,116l-8,8v157s41,27,43,36,0,36,0,36,88,9,88,42c0,29,71,32,71,32s39,2,47-22c10-7,50,1,45,18s-23,85-31,89-20,0-20,0-3,9-17,11-123,4-217-28-127-50-148-54-22-10-39,3S1030.5,2060.5,1030.5,2060.5Z",
    transform: "translate(2 2)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_4",
    "data-name": "Calque 4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1200,683s25-38,3-82V560s33.5-63.5,297.5-60.5,301,62.5,301,62.5v40.5s-35.5,57,2.5,79V712s-4,78-306,78c-227.79,0-287.18-46.65-298.32-80.31C1199.68,699,1200,692,1200,683Z",
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1211,649V625s92-50,280-50c217,0,300,51,300,51l-5,21s-86-48-295-48C1309,599,1211,649,1211,649Z",
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 1256,
    y: 606,
    width: 9,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 1613,
    y: 585,
    width: 14,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 1342,
    y: 585,
    width: 13,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 1477,
    y: 579,
    width: 16,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 1722,
    y: 607,
    width: 7,
    height: 32
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 1502,
    cy: 749,
    rx: 220,
    ry: 43
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 1502.5,
    cy: 756,
    rx: 335,
    ry: 100.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 1502.5,
    cy: 727,
    rx: 335,
    ry: 100.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1835.5,645c0,55.5-141,303.5-326,303.5s-344-248-344-303.5,150-100.5,335-100.5S1835.5,589.5,1835.5,645Z",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSituation1);
export default __webpack_public_path__ + "static/media/situation_1.77eaea67634f9da9722dadc5a8f77458.svg";
export { ForwardRef as ReactComponent };